<template>
  <div>
    <keep-alive v-if="$route.meta.keepAlive">
      <router-view></router-view>
    </keep-alive>
    <router-view v-else></router-view>
  </div>
</template>

<script>
export default {
  created() {

  },
  methods: {

  },
};
</script>

<style lang="less">
@import "style/mixin";
.weini_icon {
  display: inline-block;
  background-color: red;
  color: #fff;
  font-size: 12px;
  .weini_icon_sp {
    display: inline-block;
    padding: 0 5px;
    height: 18px;
    line-height: 18px;
  }
}
.mall_group_icon {
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  width: 65px !important;
  height: 65px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue